import type { SentryFeedbackOverrides } from './openSentryFeedbackForm';

type Translate = (key: string) => string;

/**
 * Localized values for the Sentry feedback widget's built-in chrome (description label, the
 * "(required)" suffix, screenshot/annotation tool labels, and the success/error copy) — none of
 * these are overridden by default, so without them the widget falls back to Sentry's hardcoded
 * English strings regardless of the app's current language. `t` must resolve keys under
 * `sentryFeedback.*` (see `common-translations.json` in each app).
 */
export const getSentryFeedbackTextDefaults = (t: Translate): SentryFeedbackOverrides => ({
  messageLabel: t('sentryFeedback.messageLabel'),
  isRequiredLabel: t('sentryFeedback.requiredLabel'),
  addScreenshotButtonLabel: t('sentryFeedback.addScreenshot'),
  removeScreenshotButtonLabel: t('sentryFeedback.removeScreenshot'),
  cancelButtonLabel: t('sentryFeedback.cancel'),
  confirmButtonLabel: t('sentryFeedback.confirm'),
  highlightToolText: t('sentryFeedback.highlightTool'),
  hideToolText: t('sentryFeedback.hideTool'),
  removeHighlightText: t('sentryFeedback.removeHighlight'),
  successMessageText: t('sentryFeedback.successMessage'),
  errorEmptyMessageText: t('sentryFeedback.errorEmptyMessage'),
  errorNoClientText: t('sentryFeedback.errorNoClient'),
  errorTimeoutText: t('sentryFeedback.errorTimeout'),
  errorForbiddenText: t('sentryFeedback.errorForbidden'),
  errorGenericText: t('sentryFeedback.errorGeneric'),
});

/**
 * Localized name/email field labels — only relevant where those fields are actually shown
 * (`showName`/`showEmail` left at their Sentry defaults). Apps that hide those fields
 * (`showName: false, showEmail: false`) don't need this.
 */
export const getSentryFeedbackNameEmailTextDefaults = (t: Translate): SentryFeedbackOverrides => ({
  nameLabel: t('sentryFeedback.nameLabel'),
  namePlaceholder: t('sentryFeedback.namePlaceholder'),
  emailLabel: t('sentryFeedback.emailLabel'),
  emailPlaceholder: t('sentryFeedback.emailPlaceholder'),
});
